import { type IconProps } from '@core/types/components'

export const CheckboxUncheckedIcon = ({
  className,
  color = 'var(--color-neutral-gray-06)',
  size = 24
}: IconProps) => {
  return (
    <i className={className}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect x='0.5' y='0.5' width='23' height='23' rx='3.5' stroke={color} />
      </svg>
    </i>
  )
}
